<div class="relative">
  <!-- Button -->
  <app-button variant="ghost" svgIcon="bell" (btnClick)="togglePanel()" class="trigger-button" />

  <!-- Unread count -->
  @if(unreadCount() > 0) {
  <span
    class="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-5 h-5 px-1 flex items-center justify-center"
  >
    {{ unreadCount() }}
  </span>
  }
</div>
